<template>
  <div id="principalMap" class="d-flex justify-content-center">
    <ReportDetail :icon="report_details.icon" :plate="report_details.plate" :visible="report_details.visible" :columns="report_details.columns"></ReportDetail>
  </div>
</template>

<script lang="ts">
import ReportDetail from '@/components/ReportDetail.vue'
import IReportDetails from '@/models/modelView/report-details'
import VectorService from '@/services/vector.service'
import globalModule from '@/store/modules/global.module'
import mapsModule from '@/store/modules/maps.module'
import reportsModule from '@/store/modules/reports.module'
import { Component, Vue, Watch } from 'vue-property-decorator'

@Component({
  components: { ReportDetail }
})
export default class Maps extends Vue {
  name = 'maps'
  mounted() {
    console.log('maps mount')
    globalModule.updateBodySize()
    mapsModule.initMapService()
    mapsModule.initPopupService()
  }

  get rasterActive() {
    return globalModule.rasterActive
  }

  get mapLayer() {
    return globalModule.mapLayer
  }

  get report_details(): IReportDetails {
    return reportsModule.report_details
  }

  @Watch("rasterActive", { immediate: false })
  onChangeRasterActive(rasterActive: boolean): void {
    const opacity = rasterActive ? '1' : '0.6';
    document.getElementById('raster-control')!.style.opacity = opacity;
    VectorService.setViewLayer(3, rasterActive);
  }

  @Watch("mapLayer", { immediate: false })
  onChangeMapLayer(layer: string): void {
    mapsModule.mapService.changeMap(layer)
    if (layer === 'ostm') {
      document.getElementById('osm')?.setAttribute('checked', 'true')
    } else {
      document.getElementById('bing')?.setAttribute('checked', 'true')
    }
  }
}
</script>

<style lang="sass"></style>
